if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.items = [];
        this.currentIndex = 0;
        this.counter = this.querySelector('.product-media-modal__counter');
        this.navButtons = this.querySelectorAll('.product-media-modal__nav');

        this.querySelector('.product-media-modal__nav--prev')?.addEventListener('click', () => this.step(-1));
        this.querySelector('.product-media-modal__nav--next')?.addEventListener('click', () => this.step(1));

        // ModalDialog closes media modals on any mouse click; only close when the backdrop is clicked.
        this.querySelector('[role="dialog"]').addEventListener('pointerup', (event) => {
          if (event.target.closest('.product-media-modal__nav, .product-media-modal__counter, img')) {
            event.stopPropagation();
          }
        });

        // Listen on the document so the keys still work after focus leaves the modal (e.g. clicking the image).
        this.onKeyDown = (event) => {
          if (event.code === 'ArrowLeft') this.step(-1);
          if (event.code === 'ArrowRight') this.step(1);
          if (event.code === 'Escape' && !this.contains(event.target)) this.hide();
        };

        const content = this.querySelector('[role="document"]');
        content.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.changedTouches[0].clientX;
            this.touchStartY = event.changedTouches[0].clientY;
          },
          { passive: true }
        );
        content.addEventListener(
          'touchend',
          (event) => {
            const deltaX = event.changedTouches[0].clientX - this.touchStartX;
            const deltaY = event.changedTouches[0].clientY - this.touchStartY;
            if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) this.step(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      hide() {
        document.removeEventListener('keydown', this.onKeyDown);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        document.addEventListener('keydown', this.onKeyDown);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const content = this.querySelector('[role="document"]');
        let activeMedia = content.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        while (activeMedia && activeMedia.parentElement !== content) activeMedia = activeMedia.parentElement;

        // Match the gallery on the page: hidden variant images are skipped, except the selected one.
        this.items = Array.from(content.children).filter(
          (element, index) =>
            index === 0 || element === activeMedia || !element.classList.contains('product__media-item--variant')
        );

        const activeIndex = this.items.indexOf(activeMedia);
        this.showItem(activeIndex === -1 ? 0 : activeIndex);
      }

      step(direction) {
        if (this.items.length < 2) return;
        window.pauseAllMedia();
        this.showItem(this.currentIndex + direction);
      }

      showItem(index) {
        const content = this.querySelector('[role="document"]');
        const count = this.items.length;
        if (!count) return;

        this.currentIndex = (index + count) % count;
        const activeMedia = this.items[this.currentIndex];

        Array.from(content.children).forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });
        content.scrollTop = 0;

        // Load the neighbouring images ahead of time so next/previous feels instant.
        [this.currentIndex - 1, this.currentIndex + 1].forEach((neighbourIndex) => {
          const neighbour = this.items[(neighbourIndex + count) % count];
          if (neighbour?.tagName === 'IMG') neighbour.loading = 'eager';
        });

        this.counter.textContent = `${this.currentIndex + 1} / ${count}`;
        this.counter.classList.toggle('hidden', count < 2);
        this.navButtons.forEach((button) => button.classList.toggle('hidden', count < 2));

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
